module.exports = __webpack_public_path__ + "static/startled-9fe7a884f59e86a9acd8c995616ba8f4.svg";